/* eslint-disable class-methods-use-this */
import cn from 'classnames'
import moment from 'moment'
import React from 'react'
import { SingleDatePicker } from 'react-dates'
import { ICON_AFTER_POSITION } from 'react-dates/constants'
import 'react-dates/initialize'

import { withStyles } from '@material-ui/core/styles'
import isSameDay from 'react-dates/src/utils/isSameDay'

import 'react-dates/lib/css/_datepicker.css'

import theme, { rem } from '../../utils/theme'
import Icon from '../Icon'
import LabelWrapper from '../LabelWrapper'
import DatePickerWrapper from './DatePickStyle'
import MonthYearSelect from './utils/monthYearSelect'

const styles = theme => ({
  DividerRoot: {
    backgroundColor: `${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`} !important`,
  },
})

class DatePicker extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      date: props.selectedDate || (props.allowEmpty ? null : moment()),
      focused: false,
    }

    this.datePicker = React.createRef()
  }

  componentWillReceiveProps(nextProps) {
    const { selectedDate } = this.props
    if (nextProps.selectedDate !== selectedDate) {
      this.setState({
        date: nextProps.selectedDate,
      })
    }
  }

  handleResize = () => {
    let calendarPlacement = 'down'
    const currentInputField = this.datePicker.current

    if (currentInputField) {
      const { bottom } = currentInputField.getBoundingClientRect()
      const windowHeight = window.innerHeight || document.documentElement.clientHeight

      if (bottom > windowHeight / 2) {
        calendarPlacement = 'up'
      }
    }

    return calendarPlacement
  }

  onDateChange = date => {
    const { onDateChange } = this.props
    this.setState({ date, focused: false })
    onDateChange(date)
  }

  getYears = (startYear, endYear) => {
    const currentYear = new Date().getFullYear()
    const years = []
    const startYears = startYear || 1900
    const endYears = endYear || currentYear + 10
    let i
    for (i = startYears; i <= endYears; i += 1) {
      years.push(i.toString())
    }
    return years
  }

  isFocusChange = ({ focused }) => this.setState({ focused })

  calculateAge = date => {
    if (!date || !this.props.showAge) return ''

    const currentDate = moment()
    const age = currentDate.diff(date, 'years')
    return `(${age})`
  }

  render() {
    const {
      startYear,
      endYear,
      placeholder,
      allowMargin,
      small,
      blockedDates,
      hightLightDates,
      format,
      DisplayMonths,
      classes,
      actionLink,
      className,
      customCol,
      customMargin,
      customPadding,
      customWidth,
      disabled,
      dataTestId,
      errorText,
      fullWidth,
      hasError,
      isFilter,
      helperText,
      id,
      isLabelInline,
      justify,
      isRequired,
      isToolTip,
      label,
      multipleFields,
      noMobile,
      noSpacing,
      noWrap,
      notWrapper,
      openDirection,
      showActionLink,
      showAge,
      showInPopup,
      spacing,
      toolTipIcon,
      toolTipIconColor,
      toolTipIconSize,
      toolTipPosition,
      toolTipText,
      verticalSpacing,
      withBorder,
      withDivider,
      isOutsideRange,
      isNotAppend,
      useAbsolutePosition,
      ...rest
    } = this.props
    const { date, focused } = this.state
    const years = this.getYears(startYear, endYear)
    return (
      <LabelWrapper
        actionLink={actionLink}
        className={cn({ withBorder }, 'date-picker', className)}
        customCol={customCol}
        customMargin={customMargin}
        customPadding={customPadding}
        customWidth={customWidth}
        disabled={disabled}
        errorText={errorText}
        fullWidth={fullWidth}
        hasError={hasError}
        isFilter={isFilter}
        helperText={helperText}
        id={id}
        isLabelInline={isLabelInline}
        isRequired={isRequired}
        isToolTip={isToolTip}
        justify={justify}
        label={label}
        multipleFields={multipleFields}
        noMobile={noMobile}
        noSpacing={noSpacing}
        notWrapper={notWrapper}
        noWrap={noWrap}
        showActionLink={showActionLink}
        spacing={spacing}
        toolTipIcon={toolTipIcon}
        toolTipIconColor={toolTipIconColor}
        toolTipIconSize={toolTipIconSize}
        toolTipPosition={toolTipPosition}
        toolTipText={toolTipText}
        withBorder={withBorder}
        withDivider={withDivider}
      >
        <DatePickerWrapper
          className={cn({ disabled, errorText }, `open_${openDirection}`)}
          customWidth={customWidth}
          showAge={showAge}
        >
          <div
            ref={this.datePicker}
            data-testid={dataTestId}
            style={{ display: 'flex', justifyContent: 'space-between' }}
            className={useAbsolutePosition ? 'useAbsolutePosition' : ''}
          >
            <SingleDatePicker
              disabled={disabled}
              displayFormat={format}
              date={date}
              onDateChange={date => this.onDateChange(date)}
              focused={focused}
              noBorder={!withBorder}
              readOnly
              placeholder={placeholder}
              hideKeyboardShortcutsPanel
              onFocusChange={this.isFocusChange}
              isOutsideRange={isOutsideRange || (() => false)}
              isDayBlocked={day1 => blockedDates.some(day2 => isSameDay(day1, day2))}
              isDayHighlighted={day1 => hightLightDates.some(day2 => isSameDay(day1, day2))}
              navPrev={
                <Icon
                  className="DayPickerNavigation_leftButton__horizontalDefault DayPickerNavigation_button__default DayPickerNavigation_button__horizontalDefault"
                  iconSize={25}
                  iconName="chevron-left"
                  color="grey"
                  style={{
                    backgroundColor: `var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`,
                  }}
                />
              }
              navNext={
                <Icon
                  className="DayPickerNavigation_rightButton__horizontalDefault DayPickerNavigation_button__default DayPickerNavigation_button__horizontalDefault"
                  iconSize={25}
                  iconName="chevron-right"
                  color="grey"
                  style={{
                    backgroundColor: `var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`,
                  }}
                />
              }
              renderMonthElement={item => <MonthYearSelect {...item} years={years} />}
              small={small}
              customInputIcon={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                  <div>
                    <p
                      style={{
                        width: '100%',
                        fontSize: theme.typography.fontSizeSm,
                        color: `var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor})`,
                      }}
                    >
                      {this.calculateAge(date)}
                    </p>
                  </div>
                  <Icon
                    iconSize={25}
                    iconName="lowerTriangle"
                    color="grey"
                    style={{
                      backgroundColor: `var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`,
                      marginRight: `${rem(-5)}`,
                    }}
                  />
                </div>
              }
              inputIconPosition={ICON_AFTER_POSITION}
              numberOfMonths={DisplayMonths}
              verticalSpacing={verticalSpacing}
              openDirection={this.handleResize()}
              appendToBody={isNotAppend ? false : !showInPopup}
              withPortal={showInPopup}
              id={`${id}-date-picker`}
              {...rest}
            />
          </div>
          <div
            style={{
              marginBottom: allowMargin && focused ? 365 : 0,
            }}
          />
        </DatePickerWrapper>
      </LabelWrapper>
    )
  }
}

DatePicker.defaultProps = {
  selectedDate: null,
  onDateChange: () => {},
  openDirection: 'down',
  allowEmpty: false,
  placeholder: '',
  allowMargin: false,
  small: false,
  startYear: 1900,
  endYear: 2100,
  blockedDates: [],
  hightLightDates: [],
  format: 'DD MMM YYYY',
  DisplayMonths: 1,
  customWidth: null,
  showInPopup: false,
  verticalSpacing: 0,
  notWrapper: true,
}

const DatePickerComponent = withStyles(styles)(DatePicker)
DatePickerComponent.displayName = 'DatePicker'
export default DatePickerComponent
